{
  "el": {
    "task_assignment": {
      "actions": {
        "add_assignee": "Προσθήκη υπευθύνου",
        "bulk_remove": "Αφαίρεση από την εργασία",
        "change_status": "Αλλαγή κατάστασης",
        "confirm": "Σήμανση ως ολοκληρωμένη",
        "create": "Εργασία",
        "delete": "Διαγραφή υπευθύνου",
        "document_add": "Προσθήκη αρχείου",
        "document_delete": "Διαγραφή",
        "due_in_month": "Σε έναν μήνα",
        "due_in_two_weeks": "Σε δύο εβδομάδες",
        "due_in_week": "Σε μία εβδομάδα",
        "due_remove": "Αφαίρεση προθεσμίας",
        "move_to_draft": "Επαναφορά σε πρόχειρη",
        "open": "Άνοιγμα",
        "reopen": "Άνοιγμα ξανά",
        "selectAll": "Επιλογή και των {total}",
        "send_and_notify": "Αποστολή και ειδοποίηση",
        "set_due_date": "Ορισμός προθεσμίας",
        "set_status": "Ορισμός κατάστασης",
        "unSelectAll": "Κατάργηση επιλογής",
        "upload_files": "Ανέβασμα {count} αρχείου | Ανέβασμα {count} αρχείων"
      },
      "assignee_scopes": {
        "external": "Εξωτερικό",
        "internal": "Εσωτερικό"
      },
      "assignee_types": {
        "customer": "Πελάτης",
        "employee": "Μέλος ομάδας",
        "partner": "Συνεργάτης"
      },
      "attributes": {
        "assignee": "Υπεύθυνος",
        "assignees": "Υπεύθυνοι",
        "comment": "Σχόλιο",
        "created_at": "Δημιουργήθηκε",
        "document": "Έγγραφο",
        "due_date": "Προθεσμία",
        "project": "Έργο",
        "status": "Κατάσταση",
        "task": "Εργασία",
        "unit": "Ακίνητο"
      },
      "confirm": {
        "affected": "Αυτό αφορά {customers} και {team}.",
        "affected_customers": "Αυτό αφορά {customers}.",
        "affected_team": "Αυτό αφορά {team}.",
        "bulk_affected": "Αυτό γράφει {count} εργασία. | Αυτό γράφει {count} εργασίες.",
        "bulk_delete_body": "Η εργασία παραμένει, σε αυτή τη μονάδα και σε κάθε άλλη. Φεύγουν μόνο οι επιλεγμένες γραμμές.",
        "bulk_delete_header": "Αφαίρεση αυτών των εργασιών;",
        "complete_body": "Οι εργασίες τους κλείνουν και εξαφανίζονται από τη λίστα τους, ακόμη κι αν δεν έκαναν τίποτα.",
        "complete_header": "Κλείσιμο αυτής της εργασίας για όλους;",
        "customer_tasks": "{count} εργασία πελάτη | {count} εργασίες πελατών",
        "delete_body": "Χάνεται μόνο αυτή η ανάθεση. Η εργασία κρατά τους υπόλοιπους υπευθύνους και τα υπόλοιπα ακίνητά της.",
        "delete_header": "Διαγραφή του {name} από αυτή την εργασία;",
        "delete_sent_customers": "Αυτή είχε ήδη σταλεί, οπότε χάνεται και από την πύλη πελατών του {unit}.",
        "delete_sent_team": "Αυτή είχε ήδη σταλεί, οπότε χάνεται και από τη λίστα του {name}.",
        "document_delete_body": "Το αρχείο φεύγει και από τα έγγραφα της μονάδας.",
        "document_delete_header": "Διαγραφή αυτού του αρχείου;",
        "draft_body": "Η εργασία εξαφανίζεται μέχρι να σταλεί ξανά. Τα email που έχουν ήδη φύγει παραμένουν σταλμένα.",
        "draft_header": "Επαναφορά αυτής της εργασίας σε πρόχειρη;",
        "send_customers": "Οι πελάτες βλέπουν αμέσως την εργασία στην πύλη τους και ειδοποιούνται.",
        "send_header": "Αποστολή στους υπευθύνους;",
        "send_permanent": "Η αποστολή δεν αναιρείται. Αν επαναφέρεις αργότερα την εργασία σε πρόχειρη, η ειδοποίηση δεν παίρνεται πίσω.",
        "send_status": "Περνούν σε Ζητήθηκε.",
        "send_team": "Τα μέλη της ομάδας ειδοποιούνται.",
        "team_tasks": "{count} εργασία ομάδας | {count} εργασίες ομάδας"
      },
      "deep_link": {
        "completed": "Αυτή η εργασία έχει ήδη ολοκληρωθεί.",
        "gone": "Αυτή η εργασία δεν είναι πλέον ανοιχτή."
      },
      "empty": {
        "filtered_description": "Προσάρμοσε τα φίλτρα σου ή καθάρισέ τα για να δεις όλες τις αναθέσεις.",
        "filtered_title": "Καμία ανάθεση δεν ταιριάζει με τα φίλτρα σου",
        "none_title": "Καμία ανάθεση"
      },
      "filters": {
        "due_window_values": {
          "month": "Λήγει εντός ενός μήνα",
          "none": "Χωρίς προθεσμία",
          "overdue": "Εκπρόθεσμη",
          "week": "Λήγει εντός μίας εβδομάδας"
        },
        "show_only": "Εμφάνιση μόνο",
        "show_only_values": {
          "customers": "Πελάτες",
          "mine": "Ανατεθειμένες σε εμένα",
          "team": "Ομάδα"
        }
      },
      "labels": {
        "add_assignee": "Προσθήκη υπευθύνου",
        "add_customers": "Προσθήκη πελατών",
        "already_assigned": "Αυτή η εργασία έχει ήδη προστεθεί σε αυτό το ακίνητο.",
        "already_assigned_project": "Αυτή η εργασία έχει ήδη προστεθεί σε αυτό το έργο.",
        "assignees": "Ανατεθειμένοι",
        "assignees_subtitle": "Καθένας λαμβάνει τη δική του εργασία, ανά ακίνητο.",
        "assignees_title": "Ποιος πρέπει να το κάνει",
        "comment_earlier_round": "προηγούμενος γύρος",
        "comment_placeholder": "π.χ. ο μετρητής ήταν δύσκολα προσβάσιμος, αυτή είναι η καλύτερη φωτογραφία που μπόρεσα να τραβήξω",
        "comments_none": "Ο πελάτης δεν άφησε κανένα σχόλιο.",
        "comments_title": "Σχόλια για αυτήν την εργασία",
        "completed": "Ολοκληρωμένη",
        "confirm_message": "Θέλεις σίγουρα να σημειώσεις αυτή την εργασία ως ολοκληρωμένη;",
        "customers": "Πελάτες",
        "documents_none": "Δεν έχει ανέβει τίποτα ακόμη.",
        "documents_title": "Αρχεία αυτής της εργασίας",
        "earlier": "+{count} παλαιότερα",
        "my_tasks": "Οι εργασίες μου",
        "no_assignees": "Χωρίς υπευθύνους ακόμη.",
        "no_assignments": "Δεν υπάρχουν ακόμη εργασίες.",
        "no_assignments_task": "Δεν υπάρχουν ακόμη αναθέσεις για αυτή την εργασία.",
        "no_assignments_unit": "Δεν υπάρχουν ακόμη εργασίες για αυτό το ακίνητο.",
        "previous_upload": "προηγούμενο ανέβασμα",
        "required": "Αυτό το πεδίο είναι υποχρεωτικό",
        "selectOne": "Επιλέξτε τουλάχιστον μία εργασία.",
        "select_task": "Επίλεξε μια εργασία",
        "selected": "{selected} επιλεγμένη | {selected} επιλεγμένες",
        "set_status_for": "Ορισμός κατάστασης για {name}",
        "superseded": "αντικαταστάθηκε",
        "totalSelected": "Επιλέχθηκαν και οι {total}",
        "upload_hint": "Ανέβασε τα ζητούμενα έγγραφα για να ολοκληρώσεις αυτή την εργασία.",
        "uploaded_documents": "Ανεβασμένα έγγραφα"
      },
      "statuses": {
        "completed": "Ολοκληρωμένη",
        "draft": "Πρόχειρη",
        "requested": "Ζητήθηκε"
      },
      "toasts": {
        "bulk_delete": "Οι εργασίες αφαιρέθηκαν",
        "bulk_update": "Οι εργασίες ενημερώθηκαν",
        "completed": "Η εργασία ολοκληρώθηκε",
        "create": "Η εργασία δημιουργήθηκε",
        "delete": "Ο υπεύθυνος διαγράφηκε",
        "document_added": "Το αρχείο προστέθηκε",
        "document_deleted": "Το αρχείο διαγράφηκε",
        "reopened": "Η εργασία άνοιξε ξανά",
        "update": "Η εργασία ενημερώθηκε"
      }
    }
  }
}
